export const ATTACHMENT_TYPE = {
  Photo: 0,
  Pdf: 1,
  Other: 2,
};
